import React,{useState, useEffect } from 'react';

import './DoanhNghiep.css';

function DoanhNghiep () {
//  useEffect(() => {
//   if (!window.L) return;

//   const L = window.L;

//   // kiểm tra container tồn tại
//   const mapContainer = document.getElementById("map-location-container");

//   if (!mapContainer) return;

//   // tránh leaflet báo lỗi map container already initialized
//   if (mapContainer._leaflet_id) {
//     mapContainer._leaflet_id = null;
//     mapContainer.innerHTML = "";
//   }

//   // remove map cũ nếu có
//   if (window.dashboardMapInstance) {
//     window.dashboardMapInstance.off();
//     window.dashboardMapInstance.remove();
//     window.dashboardMapInstance = null;
//   }

//   // tạo map mới
//   const map = L.map("map-location-container", {
//     zoomControl: false,
//   }).setView([21.0285, 105.8542], 15);

//   // lưu instance
//   window.dashboardMapInstance = map;

//   // tile map
//   L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
//     attribution: "",
//   }).addTo(map);

//   // zoom control
//   L.control
//     .zoom({
//       position: "topleft",
//     })
//     .addTo(map);

//   // custom marker
//   const customIcon = L.divIcon({
//     className: "map-location-marker-wrapper",
//     html: `
//       <div class="map-location-marker">
//         <div class="map-location-marker-circle"></div>
//       </div>
//     `,
//     iconSize: [40, 40],
//     iconAnchor: [20, 40],
//   });

//   // marker
//   L.marker([21.0285, 105.8542], {
//     icon: customIcon,
//   }).addTo(map);

//   // cleanup
//   return () => {
//     if (window.dashboardMapInstance) {
//       window.dashboardMapInstance.off();
//       window.dashboardMapInstance.remove();
//       window.dashboardMapInstance = null;
//     }
//   };
// }, []);



 const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);

  const handleOpen = () => {
    setShowModal(true);
    setStep(1);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleNext = () => {
    if (step < 5) {
      setStep(step + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handleSave = () => {
    setShowModal(false);
  };
        return (
<div className="enterprise-dashboard ">
  <div className="enterprise-dashboard-header">
    <div className="enterprise-dashboard-title-wrap">
      <h2 className="enterprise-dashboard-title">Doanh nghiệp</h2>

      <div className="enterprise-dashboard-breadcrumb">
        <span className="enterprise-dashboard-breadcrumb-home">
          ● Trang chủ
        </span>

        <span className="enterprise-dashboard-breadcrumb-arrow">
          &gt;
        </span>

        <span className="enterprise-dashboard-breadcrumb-current">
          Doanh nghiệp
        </span>
      </div>
    </div>

    <button className="enterprise-dashboard-add-button" onClick={handleOpen }>
      + Thêm doanh nghiệp
    </button>
  </div>

  <div className="enterprise-dashboard-toolbar">
    <div className="enterprise-dashboard-search-wrap">
      <i className="fa-solid fa-magnifying-glass"></i>

      <input
        type="text"
        className="enterprise-dashboard-search-input"
        placeholder="Tìm kiếm doanh nghiệp, MST, người đại diện..."
      />
    </div>

    <select className="enterprise-dashboard-select-industrial">
      <option>Tất cả khu công nghiệp</option>
    </select>

    <select className="enterprise-dashboard-select-industry">
      <option>Tất cả ngành nghề</option>
    </select>

    <select className="enterprise-dashboard-select-status">
      <option>Tất cả trạng thái</option>
    </select>

    <button className="enterprise-dashboard-filter-button">
      {/* <i className="fa-solid fa-sliders icon-filer"></i> */}
      <i className="fa-solid fa-filter icon-filer"></i>
      Bộ lọc
    </button>
  </div>

  <div className="enterprise-dashboard-statistics">
    <div className="enterprise-dashboard-statistics-card">
      <div className="enterprise-dashboard-statistics-icon enterprise-dashboard-statistics-icon-blue">
        <i className="fa-solid fa-building"></i>
      </div>

      <div className="enterprise-dashboard-statistics-content">
        <span className="enterprise-dashboard-statistics-label">
          Tổng số doanh nghiệp
        </span>

        <h3 className="enterprise-dashboard-statistics-number">
          356
        </h3>

        <span className="enterprise-dashboard-statistics-desc">
          +12 doanh nghiệp
        </span>
      </div>
    </div>

    <div className="enterprise-dashboard-statistics-card">
      <div className="enterprise-dashboard-statistics-icon enterprise-dashboard-statistics-icon-green">
        <i className="fa-solid fa-check"></i>
      </div>

      <div className="enterprise-dashboard-statistics-content">
        <span className="enterprise-dashboard-statistics-label">
          Đang hoạt động
        </span>

        <h3 className="enterprise-dashboard-statistics-number">
          312
        </h3>

        <span className="enterprise-dashboard-statistics-desc">
          87,6%
        </span>
      </div>
    </div>

    <div className="enterprise-dashboard-statistics-card">
      <div className="enterprise-dashboard-statistics-icon enterprise-dashboard-statistics-icon-yellow">
        <i className="fa-solid fa-clock"></i>
      </div>

      <div className="enterprise-dashboard-statistics-content">
        <span className="enterprise-dashboard-statistics-label">
          Tạm dừng
        </span>

        <h3 className="enterprise-dashboard-statistics-number">
          28
        </h3>

        <span className="enterprise-dashboard-statistics-desc">
          7,9%
        </span>
      </div>
    </div>

    <div className="enterprise-dashboard-statistics-card">
      <div className="enterprise-dashboard-statistics-icon enterprise-dashboard-statistics-icon-red">
        <i className="fa-solid fa-xmark"></i>
      </div>

      <div className="enterprise-dashboard-statistics-content">
        <span className="enterprise-dashboard-statistics-label">
          Ngừng hoạt động
        </span>

        <h3 className="enterprise-dashboard-statistics-number">
          16
        </h3>

        <span className="enterprise-dashboard-statistics-desc">
          4,5%
        </span>
      </div>
    </div>

    <div className="enterprise-dashboard-statistics-card">
      <div className="enterprise-dashboard-statistics-icon enterprise-dashboard-statistics-icon-purple">
        <i className="fa-solid fa-users"></i>
      </div>

      <div className="enterprise-dashboard-statistics-content">
        <span className="enterprise-dashboard-statistics-label">
          Tổng lao động
        </span>

        <h3 className="enterprise-dashboard-statistics-number">
          134.567
        </h3>

        <span className="enterprise-dashboard-statistics-desc">
          +1.245 người
        </span>
      </div>
    </div>
  </div>

  <div className="enterprise-dashboard-chart-layout">
    {/* <!-- PIE CHART --> */}
    <div className="enterprise-dashboard-chart-card">
      <div className="enterprise-dashboard-chart-header">
        <h3 className="enterprise-dashboard-chart-title">
          Doanh nghiệp theo khu công nghiệp
        </h3>
      </div>

      <div className="enterprise-dashboard-pie-layout">
        <div className="enterprise-dashboard-pie-chart">
          <div className="enterprise-dashboard-pie-circle">
            <div className="enterprise-dashboard-pie-center">
              <span className="enterprise-dashboard-pie-total">
                356
              </span>

              <span className="enterprise-dashboard-pie-text">
                Doanh nghiệp
              </span>
            </div>

            <span className="enterprise-dashboard-pie-label enterprise-dashboard-pie-label-blue">
              35,1%
            </span>

            <span className="enterprise-dashboard-pie-label enterprise-dashboard-pie-label-green">
              24,2%
            </span>

            <span className="enterprise-dashboard-pie-label enterprise-dashboard-pie-label-orange">
              12,9%
            </span>

            <span className="enterprise-dashboard-pie-label enterprise-dashboard-pie-label-purple">
              9,3%
            </span>

            <span className="enterprise-dashboard-pie-label enterprise-dashboard-pie-label-violet">
              9,3%
            </span>
          </div>
        </div>

        <div className="enterprise-dashboard-pie-legend">
             <div className="enterprise-dashboard-pie-total-row-head">
            <span>Khu công nghiệp</span>
            <span>Số doanh nghiệp</span>
          </div>
          <div className="enterprise-dashboard-pie-legend-row">
            <div className="enterprise-dashboard-pie-legend-left">
              <span className="enterprise-dashboard-pie-dot enterprise-dashboard-pie-dot-blue"></span>
              <span>KCN Bình Hòa</span>
            </div>

            <span>125 (35,1%)</span>
          </div>

          <div className="enterprise-dashboard-pie-legend-row">
            <div className="enterprise-dashboard-pie-legend-left">
              <span className="enterprise-dashboard-pie-dot enterprise-dashboard-pie-dot-green"></span>
              <span>KCN Vàm Cống</span>
            </div>

            <span>86 (24,2%)</span>
          </div>

          <div className="enterprise-dashboard-pie-legend-row">
            <div className="enterprise-dashboard-pie-legend-left">
              <span className="enterprise-dashboard-pie-dot enterprise-dashboard-pie-dot-lightgreen"></span>
              <span>KCN Bình Hòa 2</span>
            </div>

            <span>66 (18,5%)</span>
          </div>

          <div className="enterprise-dashboard-pie-legend-row">
            <div className="enterprise-dashboard-pie-legend-left">
              <span className="enterprise-dashboard-pie-dot enterprise-dashboard-pie-dot-orange"></span>
              <span>KCN Thoại Sơn</span>
            </div>

            <span>46 (12,9%)</span>
          </div>

          <div className="enterprise-dashboard-pie-legend-row">
            <div className="enterprise-dashboard-pie-legend-left">
              <span className="enterprise-dashboard-pie-dot enterprise-dashboard-pie-dot-purple"></span>
              <span>KCN Hội An</span>
            </div>

            <span>33 (9,3%)</span>
          </div>

          <div className="enterprise-dashboard-pie-total-row">
            <span>Tổng cộng</span>
            <span>356</span>
          </div>
        </div>
      </div>
    </div>

    {/* <!-- LINE CHART --> */}
    <div className="enterprise-dashboard-chart-card">
      <div className="enterprise-dashboard-chart-header">
        <h3 className="enterprise-dashboard-chart-title">
          Doanh nghiệp theo thời gian
        </h3>

        <select className="enterprise-dashboard-chart-year">
          <option>Năm 2026</option>
        </select>
      </div>

      <div className="enterprise-dashboard-line-chart">
        <div className="enterprise-dashboard-line-y-axis">
          <span>400</span>
          <span>320</span>
          <span>240</span>
          <span>160</span>
          <span>80</span>
          <span>0</span>
        </div>

        <div className="enterprise-dashboard-line-chart-main">
          <div className="enterprise-dashboard-line-grid"></div>

          <svg
            className="enterprise-dashboard-line-svg"
            viewBox="0 0 700 260"
          >
            <polyline
              fill="none"
              stroke="#4f46e5"
              strokeWidth="3"
              points="
              30,190
              90,182
              150,176
              210,170
              270,162
              330,156
              390,150
              450,144
              510,138
              570,132
              630,126
              690,120
            "
            />

            <circle cx="30" cy="190" r="5" fill="#4f46e5"></circle>
            <circle cx="90" cy="182" r="5" fill="#4f46e5"></circle>
            <circle cx="150" cy="176" r="5" fill="#4f46e5"></circle>
            <circle cx="210" cy="170" r="5" fill="#4f46e5"></circle>
            <circle cx="270" cy="162" r="5" fill="#4f46e5"></circle>
            <circle cx="330" cy="156" r="5" fill="#4f46e5"></circle>
            <circle cx="390" cy="150" r="5" fill="#4f46e5"></circle>
            <circle cx="450" cy="144" r="5" fill="#4f46e5"></circle>
            <circle cx="510" cy="138" r="5" fill="#4f46e5"></circle>
            <circle cx="570" cy="132" r="5" fill="#4f46e5"></circle>
            <circle cx="630" cy="126" r="5" fill="#4f46e5"></circle>
            <circle cx="690" cy="120" r="5" fill="#4f46e5"></circle>

            <text x="18" y="176">298</text>
            <text x="78" y="168">305</text>
            <text x="138" y="162">310</text>
            <text x="198" y="156">326</text>
            <text x="258" y="148">331</text>
            <text x="318" y="142">335</text>
            <text x="378" y="136">339</text>
            <text x="438" y="130">342</text>
            <text x="498" y="124">346</text>
            <text x="558" y="118">350</text>
            <text x="618" y="112">353</text>
            <text x="678" y="106">356</text>
          </svg>

          <div className="enterprise-dashboard-line-x-axis">
            <span>01</span>
            <span>02</span>
            <span>03</span>
            <span>04</span>
            <span>05</span>
            <span>06</span>
            <span>07</span>
            <span>08</span>
            <span>09</span>
            <span>10</span>
            <span>11</span>
            <span>12</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* <!-- TABLE --> */}
  <div className="enterprise-dashboard-table-card">
    <div className="enterprise-dashboard-table-header">
      <h3 className="enterprise-dashboard-table-title">
        Danh sách doanh nghiệp
      </h3>

      <div className="enterprise-dashboard-table-actions">
        <button className="enterprise-dashboard-export-button">
          <i className="fa-solid fa-download icon-solod-download"></i>
          Xuất excel
        </button>

        <button className="enterprise-dashboard-icon-button">
          <i className="fa-solid fa-list"></i>
        </button>

        <button className="enterprise-dashboard-icon-button">
          <i className="fa-solid fa-table-cells"></i>
        </button>

        <button className="enterprise-dashboard-icon-button">
          <i className="fa-solid fa-gear"></i>
        </button>
      </div>
    </div>

    <table className="enterprise-dashboard-table">
      <thead>
        <tr>
          <th>STT</th>
          <th>Tên doanh nghiệp</th>
          <th>Mã số thuế</th>
          <th>Khu công nghiệp</th>
          <th>Ngành nghề chính</th>
          <th>Người đại diện</th>
          <th>Lao động</th>
          <th>Trạng thái</th>
          <th>Thao tác</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>1</td>
          <td>Công ty TNHH An Giang Garment</td>
          <td>1601234567</td>
          <td>KCN Bình Hòa</td>
          <td>Sản xuất trang phục</td>
          <td>Nguyễn Văn An</td>
          <td>1.250</td>

          <td>
            <span className="enterprise-dashboard-status-active">
              Đang hoạt động
            </span>
          </td>

          <td>
            <div className="enterprise-dashboard-table-icons">
              <i className="fa-regular fa-eye"></i>
              <i className="fa-regular fa-pen-to-square"></i>
              <i className="fa-solid fa-ellipsis"></i>
            </div>
          </td>
        </tr>

        <tr>
          <td>2</td>
          <td>Công ty CP Thủy sản An Giang</td>
          <td>1601234568</td>
          <td>KCN Vàm Cống</td>
          <td>Chế biến thủy sản</td>
          <td>Trần Thị Bích Hằng</td>
          <td>850</td>

          <td>
            <span className="enterprise-dashboard-status-active">
              Đang hoạt động
            </span>
          </td>

          <td>
            <div className="enterprise-dashboard-table-icons">
              <i className="fa-regular fa-eye"></i>
              <i className="fa-regular fa-pen-to-square"></i>
              <i className="fa-solid fa-ellipsis"></i>
            </div>
          </td>
        </tr>

        <tr>
          <td>3</td>
          <td>Công ty TNHH MTV An Phú Plastic</td>
          <td>1601234569</td>
          <td>KCN Bình Hòa 2</td>
          <td>Sản xuất nhựa</td>
          <td>Lê Minh Tâm</td>
          <td>620</td>

          <td>
            <span className="enterprise-dashboard-status-pending">
              Tạm dừng
            </span>
          </td>

          <td>
            <div className="enterprise-dashboard-table-icons">
              <i className="fa-regular fa-eye"></i>
              <i className="fa-regular fa-pen-to-square"></i>
              <i className="fa-solid fa-ellipsis"></i>
            </div>
          </td>
        </tr>

        <tr>
          <td>4</td>
          <td>Công ty CP Điện tử AG</td>
          <td>1601234570</td>
          <td>KCN Thoại Sơn</td>
          <td>Sản xuất linh kiện điện tử</td>
          <td>Phạm Hoàng Nam</td>
          <td>1120</td>

          <td>
            <span className="enterprise-dashboard-status-active">
              Đang hoạt động
            </span>
          </td>

          <td>
            <div className="enterprise-dashboard-table-icons">
              <i className="fa-regular fa-eye"></i>
              <i className="fa-regular fa-pen-to-square"></i>
              <i className="fa-solid fa-ellipsis"></i>
            </div>
          </td>
        </tr>

        <tr>
          <td>5</td>
          <td>Công ty TNHH Cơ khí An Giang</td>
          <td>1601234571</td>
          <td>KCN Hội An</td>
          <td>Cơ khí chế tạo</td>
          <td>Đặng Quốc Huy</td>
          <td>430</td>

          <td>
            <span className="enterprise-dashboard-status-stop">
              Ngừng hoạt động
            </span>
          </td>

          <td>
            <div className="enterprise-dashboard-table-icons">
              <i className="fa-regular fa-eye"></i>
              <i className="fa-regular fa-pen-to-square"></i>
              <i className="fa-solid fa-ellipsis"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div className="enterprise-dashboard-pagination">
      <span className="one-to-five">
        Hiển thị 1 - 5 trong tổng số 356 doanh nghiệp
      </span>

      <div className="enterprise-dashboard-pagination-right">
        <select className="enterprise-dashboard-pagination-select">
          <option>10 / trang</option>
        </select>

        <div className="enterprise-dashboard-pagination-number-wrap">
          <button className="enterprise-dashboard-pagination-arrow">
            &lt;
          </button>

          <button className="enterprise-dashboard-pagination-active">
            1
          </button>

          <button className="enterprise-dashboard-pagination-number">
            2
          </button>

          <button className="enterprise-dashboard-pagination-number">
            3
          </button>

          <span className="enterprise-dashboard-pagination-dots">
            ...
          </span>

          <button className="enterprise-dashboard-pagination-number">
            36
          </button>

          <button className="enterprise-dashboard-pagination-arrow">
            &gt;
          </button>
        </div>
      </div>
    </div>
  </div>





























  {/* CHUYỂN TIẾP 5 MÀN HÌNH */}
    {/* OVERLAY MODAL */}
     {showModal && (
            <div className="enterprise-modal-overlay">
              <div className="enterprise-modal-container">
                <div className="enterprise-modal-scroll">
                  {/* HEADER */}
                  <div className="enterprise-modal-header">
                    <span className="enterprise-modal-breadcrumb">
                      Trang chủ {">"} Doanh nghiệp {">"} Thêm doanh nghiệp
                    </span>

                    {/* <h2 className="enterprise-modal-title">
                      Thêm doanh nghiệp
                    </h2> */}
                  </div>

                  {/* STEP */}
                  <div className="enterprise-step-wrapper">
                    <div className="enterprise-step-item">
                      <div
                        className={
                          step >= 1
                            ? "enterprise-step-number-active"
                            : "enterprise-step-number"
                        }
                      >
                        {step > 1 ? "✓" : "1"}
                      </div>

                      <span className="enterprise-step-text">
                        Thông tin chung
                      </span>
                    </div>

                    <div className="enterprise-step-line"></div>

                    <div className="enterprise-step-item">
                      <div
                        className={
                          step >= 2
                            ? "enterprise-step-number-active"
                            : "enterprise-step-number"
                        }
                      >
                        {step > 2 ? "✓" : "2"}
                      </div>

                      <span className="enterprise-step-text">
                        Thông tin chi tiết
                      </span>
                    </div>

                    <div className="enterprise-step-line"></div>

                    <div className="enterprise-step-item">
                      <div
                        className={
                          step >= 3
                            ? "enterprise-step-number-active"
                            : "enterprise-step-number"
                        }
                      >
                        {step > 3 ? "✓" : "3"}
                      </div>

                      <span className="enterprise-step-text">
                        Tài liệu đính kèm
                      </span>
                    </div>

                    <div className="enterprise-step-line"></div>

                    <div className="enterprise-step-item">
                      <div
                        className={
                          step >= 4
                            ? "enterprise-step-number-active"
                            : "enterprise-step-number"
                        }
                      >
                        {step > 4 ? "✓" : "4"}
                      </div>

                      <span className="enterprise-step-text">
                        Xác nhận
                      </span>
                    </div>
                  </div>

                  {/* STEP 1 */}
                  {step === 1 && (
                    <div className="enterprise-step-content">
                      <div className="enterprise-form-grid">
                        {/* LEFT */}
                        <div className="enterprise-form-left">
                          <h3 className="enterprise-form-section-title">
                            Thông tin chung
                          </h3>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Tên doanh nghiệp 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập tên doanh nghiệp"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Tên viết tắt
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập tên viết tắt"
                              />
                            </div>
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Mã số thuế 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập mã số thuế"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Số ĐKKD
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập số ĐKKD"
                              />
                            </div>
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Loại hình doanh nghiệp 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <select className="enterprise-form-select">
                                <option>
                                  Chọn loại hình doanh nghiệp
                                </option>
                              </select>
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Ngày cấp ĐKKD 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="date"
                                className="enterprise-form-input"
                              />
                            </div>
                          </div>

                          <div className="enterprise-form-group-full">
                            <label className="enterprise-form-label">
                              Cơ quan cấp
                            </label>

                            <input
                              type="text"
                              className="enterprise-form-input-full"
                              placeholder="Nhập cơ quan cấp"
                            />
                          </div>

                          <div className="enterprise-form-group-full">
                            <label className="enterprise-form-label">
                              Khu công nghiệp 
                              <span className='text-danger ml-2'>*</span>
                            </label>


                            <select className="enterprise-form-select-full">
                              <option>Chọn khu công nghiệp</option>
                            </select>
                          </div>

                          <div className="enterprise-form-group-full">
                            <label className="enterprise-form-label">
                              Địa chỉ trụ sở chính 
                              <span className='text-danger ml-2'>*</span>
                            </label>

                            <input
                              type="text"
                              className="enterprise-form-input-full"
                              placeholder="Nhập địa chỉ trụ sở chính"
                            />
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Tỉnh/Thành phố 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <select className="enterprise-form-select">
                                <option>An Giang</option>
                              </select>
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Huyện/Thị xã/Thành phố 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <select className="enterprise-form-select">
                                <option>
                                  Chọn huyện/thị xã/thành phố
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Xã/Phường/Thị trấn 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <select className="enterprise-form-select">
                                <option>
                                  Chọn xã/phường/thị trấn
                                </option>
                              </select>
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Số điện thoại
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập số điện thoại"
                              />
                            </div>
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Email
                              </label>

                              <input
                                type="email"
                                className="enterprise-form-input"
                                placeholder="Nhập email"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Website
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập website"
                              />
                            </div>
                          </div>

                          <div className="enterprise-status-group">
                            <span className="enterprise-form-label">
                              Trạng thái 
                              <span className='text-danger ml-2'>*</span>
                            </span>

                            <div className="enterprise-radio-wrapper">
                              <label className="enterprise-radio-item">
                                <input type="radio" name="status" checked />
                                Đang hoạt động
                              </label>

                              <label className="enterprise-radio-item">
                                <input type="radio" name="status" />
                                Ngừng hoạt động
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* RIGHT */}
                        <div className="enterprise-form-right">
                          <h3 className="enterprise-form-section-title">
                            Người đại diện theo pháp luật
                          </h3>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Họ và tên 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập họ và tên"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Chức danh 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập chức danh"
                              />
                            </div>
                          </div>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Số điện thoại 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập số điện thoại"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Email 
                                <span className='text-danger ml-2'>*</span>
                              </label>

                              <input
                                type="email"
                                className="enterprise-form-input"
                                placeholder="Nhập email"
                              />
                            </div>
                          </div>

                          <h3 className="enterprise-form-section-title">
                            Ngành nghề kinh doanh chính
                          </h3>

                          <div className="enterprise-form-group-full">
                            <label className="enterprise-form-label">
                              Ngành nghề chính 
                              <span className='text-danger ml-2'>*</span>
                            </label>

                            <select className="enterprise-form-select-full">
                              <option>Chọn ngành nghề chính</option>
                            </select>
                          </div>

                          <div className="enterprise-form-group-full">
                            <label className="enterprise-form-label">
                              Mô tả ngành nghề chính
                            </label>

                            <textarea
                              className="enterprise-form-textarea"
                              placeholder="Nhập mô tả"
                            ></textarea>
                          </div>

                          <h3 className="enterprise-form-section-title">
                            Quy mô doanh nghiệp
                          </h3>

                          <div className="enterprise-form-row">
                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Tổng vốn đầu tư
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập tổng vốn"
                              />
                            </div>

                            <div className="enterprise-form-group">
                              <label className="enterprise-form-label">
                                Vốn điều lệ
                              </label>

                              <input
                                type="text"
                                className="enterprise-form-input"
                                placeholder="Nhập vốn điều lệ"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="enterprise-footer-button">
                        <button
                          className="enterprise-cancel-button"
                          onClick={handleClose}
                        >
                          Hủy
                        </button>

                        <div className="enterprise-footer-right">
                          <button className="enterprise-save-button" onClick={handleSave}>
                            Lưu tạm
                          </button>

                          <button
                            className="enterprise-next-button"
                            onClick={handleNext}
                          >
                            Tiếp tục
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* STEP 2 */}
                  {step === 2 && (
                    <div className="enterprise-next-step">
                      <h2 className="enterprise-demo-title">
                      </h2>
                       {/* CONTENT */}
                        <div className="enterprise-detail-wrapper">

        {/* <!-- breadcrumb --> */}
        {/* <div className="enterprise-detail-breadcrumb">
            <span className="enterprise-detail-breadcrumb-home">Trang chủ</span>
            <span className="enterprise-detail-breadcrumb-arrow">></span>

            <span className="enterprise-detail-breadcrumb-business">Doanh nghiệp</span>
            <span className="enterprise-detail-breadcrumb-arrow-two">></span>

            <span className="enterprise-detail-breadcrumb-current">Thông tin chi tiết</span>
        </div> */}

        {/* <!-- title --> */}
        <div className="enterprise-detail-title">
            Thông tin chi tiết doanh nghiệp
        </div>

        {/* <!-- top button --> */}
        <div className="enterprise-detail-top-action">
          <div>
              <button className="enterprise-detail-back-button mr-2" onClick={handleBack}>
                <i className="fa-solid fa-arrow-left mr-2"></i>
                 Quay lại danh sách
            </button>
              <button className="enterprise-detail-next-button" onClick={handleNext}>
             Tiếp tục 
             <i className="fa-solid fa-arrow-right ml-2"></i>
            </button>
          </div>

            <div className="enterprise-detail-right-action">
                <button className="enterprise-detail-edit-button">
                    ✎ Sửa thông tin
                </button>

                <button className="enterprise-detail-pdf-button">
                    ⭳ Xuất PDF
                </button>

                <button className="enterprise-detail-more-button">
                 
                    ⋯ Khác
                     <i className="fa-solid fa-angle-down ml-5"></i>
                </button>
            </div>
        </div>

        {/* <!-- company info --> */}
        <div className="enterprise-detail-company-box">

            <div className="enterprise-detail-company-left">

                <div className="enterprise-detail-company-logo">
                    <img
                        className="enterprise-detail-company-logo-image"
                        src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                        alt=""
                    />
                </div>

                <div className="enterprise-detail-company-content">

                    <div className="enterprise-detail-company-name-row">
                        <div className="enterprise-detail-company-name">
                            Công ty TNHH An Giang Garment
                        </div>

                        <div className="enterprise-detail-company-status">
                            Đang hoạt động
                        </div>
                    </div>

                    <div className="enterprise-detail-company-information">

                        <div className="enterprise-detail-company-item">
                            <div className="enterprise-detail-company-item-label">
                                Mã số thuế
                            </div>

                            <div className="enterprise-detail-company-item-value">
                                1601234567
                            </div>
                        </div>

                        <div className="enterprise-detail-company-item">
                            <div className="enterprise-detail-company-item-label">
                                Số ĐKKD
                            </div>

                            <div className="enterprise-detail-company-item-value">
                                1601234567
                            </div>
                        </div>

                        <div className="enterprise-detail-company-item">
                            <div className="enterprise-detail-company-item-label">
                                Loại hình doanh nghiệp
                            </div>

                            <div className="enterprise-detail-company-item-value">
                                Công ty TNHH 2 thành viên trở lên
                            </div>
                        </div>

                        <div className="enterprise-detail-company-item">
                            <div className="enterprise-detail-company-item-label">
                                Khu công nghiệp
                            </div>

                            <div className="enterprise-detail-company-item-value">
                                KCN Bình Hòa
                            </div>
                        </div>

                        <div className="enterprise-detail-company-item">
                            <div className="enterprise-detail-company-item-label">
                                Ngày cấp ĐKKD
                            </div>

                            <div className="enterprise-detail-company-item-value">
                                15/06/2015
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        {/* <!-- tabs --> */}
        <div className="enterprise-detail-tab-wrapper">

            <div className="enterprise-detail-tab-active">
                Thông tin chung
            </div>

            <div className="enterprise-detail-tab-item">
                Đầu tư
            </div>

            <div className="enterprise-detail-tab-item-two">
                Đất đai
            </div>

            <div className="enterprise-detail-tab-item-three">
                Lao động
            </div>

            <div className="enterprise-detail-tab-item-four">
                Sản xuất kinh doanh
            </div>

            <div className="enterprise-detail-tab-item-five">
                Môi trường
            </div>

            <div className="enterprise-detail-tab-item-six">
                Hồ sơ - Tài liệu
            </div>

            <div className="enterprise-detail-tab-item-seven">
                Lịch sử thay đổi
            </div>

        </div>

        {/* <!-- content --> */}
        <div className="enterprise-detail-main-content">

            {/* <!-- left --> */}
            <div className="enterprise-detail-left-content">

                <div className="enterprise-detail-common-box">

                    <div className="enterprise-detail-common-title">
                        Thông tin chung
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Tên doanh nghiệp
                        </div>

                        <div className="enterprise-detail-common-value">
                            Công ty TNHH An Giang Garment
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Tên viết tắt
                        </div>

                        <div className="enterprise-detail-common-value">
                            An Giang Garment Co., Ltd
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Mã số thuế
                        </div>

                        <div className="enterprise-detail-common-value">
                            1601234567
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Số ĐKKD
                        </div>

                        <div className="enterprise-detail-common-value">
                            1601234567
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Loại hình doanh nghiệp
                        </div>

                        <div className="enterprise-detail-common-value">
                            Công ty TNHH 2 thành viên trở lên
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Ngày cấp ĐKKD
                        </div>

                        <div className="enterprise-detail-common-value">
                            15/06/2015
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Nơi cấp
                        </div>

                        <div className="enterprise-detail-common-value">
                            Sở Kế hoạch và Đầu tư tỉnh An Giang
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Địa chỉ trụ sở chính
                        </div>

                        <div className="enterprise-detail-common-value">
                            Số 123, đường Trần Hưng Đạo, P. Mỹ Thới, TP. Long Xuyên, tỉnh An Giang
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Điện thoại
                        </div>

                        <div className="enterprise-detail-common-value">
                            0296 1234 567
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Email
                        </div>

                        <div className="enterprise-detail-common-value">
                            info@angianggarment.vn
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Website
                        </div>

                        <div className="enterprise-detail-common-value-link">
                            https://www.angianggarment.vn
                        </div>
                    </div>

                    <div className="enterprise-detail-common-row">
                        <div className="enterprise-detail-common-label">
                            Trạng thái
                        </div>

                        <div className="enterprise-detail-common-status">
                            Đang hoạt động
                        </div>
                    </div>

                </div>

            </div>

            {/* <!-- right --> */}
            <div className="enterprise-detail-right-content">

                {/* <!-- legal --> */}
                <div className="enterprise-detail-legal-box">

                    <div className="enterprise-detail-legal-title">
                        Người đại diện theo pháp luật
                    </div>

                    <div className="enterprise-detail-legal-row">
                        <div className="enterprise-detail-legal-label">
                            Họ và tên
                        </div>

                        <div className="enterprise-detail-legal-value">
                            Nguyễn Văn An
                        </div>
                    </div>

                    <div className="enterprise-detail-legal-row">
                        <div className="enterprise-detail-legal-label">
                            Chức danh
                        </div>

                        <div className="enterprise-detail-legal-value">
                            Giám đốc
                        </div>
                    </div>

                    <div className="enterprise-detail-legal-row">
                        <div className="enterprise-detail-legal-label">
                            Số CCCD/CMND
                        </div>

                        <div className="enterprise-detail-legal-value">
                            089012345678
                        </div>
                    </div>

                    <div className="enterprise-detail-legal-row">
                        <div className="enterprise-detail-legal-label">
                            Số điện thoại
                        </div>

                        <div className="enterprise-detail-legal-value">
                            0912 345 678
                        </div>
                    </div>

                    <div className="enterprise-detail-legal-row">
                        <div className="enterprise-detail-legal-label">
                            Email
                        </div>

                        <div className="enterprise-detail-legal-value">
                            nguyenvanan@angianggarment.vn
                        </div>
                    </div>

                </div>

                {/* <!-- industry --> */}
                <div className="enterprise-detail-industry-box">

                    <div className="enterprise-detail-industry-title">
                        Ngành nghề kinh doanh chính
                    </div>

                    <table className="enterprise-detail-industry-table">

                        <thead className="enterprise-detail-industry-thead">
                            <tr className="enterprise-detail-industry-head-row">

                                <th className="enterprise-detail-industry-head-stt">
                                    STT
                                </th>

                                <th className="enterprise-detail-industry-head-name">
                                    Ngành nghề chính
                                </th>

                                <th className="enterprise-detail-industry-head-code">
                                    Mã ngành
                                </th>

                            </tr>
                        </thead>

                        <tbody className="enterprise-detail-industry-tbody">

                            <tr className="enterprise-detail-industry-body-row">

                                <td className="enterprise-detail-industry-body-stt">
                                    1
                                </td>

                                <td className="enterprise-detail-industry-body-name">
                                    Sản xuất trang phục (trừ trang phục từ da lông thú)
                                </td>

                                <td className="enterprise-detail-industry-body-code">
                                    1410
                                </td>

                            </tr>

                            <tr className="enterprise-detail-industry-body-row-two">

                                <td className="enterprise-detail-industry-body-stt-two">
                                    2
                                </td>

                                <td className="enterprise-detail-industry-body-name-two">
                                    Sản xuất hàng dệt sẵn (trừ trang phục)
                                </td>

                                <td className="enterprise-detail-industry-body-code-two">
                                    1392
                                </td>

                            </tr>

                        </tbody>

                    </table>

                    <div className="enterprise-detail-industry-more">
                        Xem thêm 3 ngành nghề khác ▼
                    </div>

                </div>

            </div>

        </div>

        {/* <!-- bottom statistic --> */}
        <div className="enterprise-detail-statistic-wrapper">

            <div className="enterprise-detail-statistic-card">

                <div className="enterprise-detail-statistic-icon">
                    💰
                </div>

                <div className="enterprise-detail-statistic-title">
                    Vốn điều lệ
                </div>

                <div className="enterprise-detail-statistic-value">
                    50.000.000.000 đồng
                </div>

                <div className="enterprise-detail-statistic-sub">
                    (Năm mươi tỷ đồng)
                </div>

            </div>

            <div className="enterprise-detail-statistic-card-two">

                <div className="enterprise-detail-statistic-icon-two">
                    🏦
                </div>

                <div className="enterprise-detail-statistic-title-two">
                    Tổng vốn đầu tư
                </div>

                <div className="enterprise-detail-statistic-value-two">
                    80.000.000.000 đồng
                </div>

                <div className="enterprise-detail-statistic-sub-two">
                    (Tám mươi tỷ đồng)
                </div>

            </div>

            <div className="enterprise-detail-statistic-card-three">

                <div className="enterprise-detail-statistic-icon-three">
                    📍
                </div>

                <div className="enterprise-detail-statistic-title-three">
                    Diện tích đất thuê
                </div>

                <div className="enterprise-detail-statistic-value-three">
                    10 ha
                </div>

                <div className="enterprise-detail-statistic-sub-three">
                    Diện tích đã sử dụng: 8 ha
                </div>

            </div>

            <div className="enterprise-detail-statistic-card-four">

                <div className="enterprise-detail-statistic-icon-four">
                    ⏰
                </div>

                <div className="enterprise-detail-statistic-title-four">
                    Thời gian hoạt động
                </div>

                <div className="enterprise-detail-statistic-value-four">
                    Từ ngày 15/06/2015
                </div>

                <div className="enterprise-detail-statistic-sub-four">
                    (10 năm 11 tháng)
                </div>

            </div>

        </div>

    </div>
{/* 
                      <div className="enterprise-footer-button">
                        <button
                          className="enterprise-back-button"
                          onClick={handleBack}
                        >
                          Quay lại
                        </button>

                        <div className="enterprise-footer-right">
                          <button className="enterprise-save-button">
                            Lưu tạm
                          </button>

                          <button
                            className="enterprise-next-button"
                            onClick={handleNext}
                          >
                            Tiếp tục
                          </button>
                        </div>
                      </div> */}
                    </div>
                  )}

                  {/* STEP 3 */}
                  {step === 3 && (
                    <div className="enterprise-next-step">
                      {/* <h2 className="enterprise-demo-title">
                        Nội dung ảnh 4
                      </h2> */}
                        <div className="enterprise-detail-page">

        {/* <!-- breadcrumb --> */}
        {/* <div className="enterprise-detail-breadcrumb">
            <span className="enterprise-detail-breadcrumb-home">Trang chủ</span>

            <span className="enterprise-detail-breadcrumb-arrow">›</span>

            <span className="enterprise-detail-breadcrumb-business">
                Doanh nghiệp
            </span>

            <span className="enterprise-detail-breadcrumb-arrow">
                ›
            </span>

            <span className="enterprise-detail-breadcrumb-current">
                Thêm doanh nghiệp
            </span>
        </div> */}

        {/* <!-- title --> */}
        <div className="enterprise-detail-title-wrapper">
            <h2 className="enterprise-detail-title">
                Thêm doanh nghiệp
            </h2>
        </div>

        {/* <!-- step --> */}
        {/* <div className="enterprise-detail-step-wrapper">

            <div className="enterprise-detail-step-item">
                <div className="enterprise-detail-step-circle-success">
                    ✓
                </div>

                <span className="enterprise-detail-step-text-success">
                    Thông tin chung
                </span>
            </div>

            <div className="enterprise-detail-step-line"></div>

            <div className="enterprise-detail-step-item">
                <div className="enterprise-detail-step-circle-active">
                    2
                </div>

                <span className="enterprise-detail-step-text-active">
                    Thông tin chi tiết
                </span>
            </div>

            <div className="enterprise-detail-step-line"></div>

            <div className="enterprise-detail-step-item">
                <div className="enterprise-detail-step-circle-default">
                    3
                </div>

                <span className="enterprise-detail-step-text-default">
                    Tài liệu đính kèm
                </span>
            </div>

            <div className="enterprise-detail-step-line"></div>

            <div className="enterprise-detail-step-item">
                <div className="enterprise-detail-step-circle-default">
                    4
                </div>

                <span className="enterprise-detail-step-text-default">
                    Xác nhận
                </span>
            </div>

        </div> */}

        {/* <!-- content --> */}
        <div className="enterprise-detail-content-wrapper">

            {/* <!-- left --> */}
            <div className="enterprise-detail-left">

                <div className="enterprise-detail-left-card">

                    <h3 className="enterprise-detail-section-title">
                        Thông tin chi tiết
                    </h3>

                    {/* <!-- thong tin lien he --> */}
                    <div className="enterprise-detail-sub-title">
                        Thông tin liên hệ
                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Điện thoại
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-phone-input"
                                placeholder="Nhập số điện thoại"
                            />
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Di động
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-mobile-input"
                                placeholder="Nhập số di động"
                            />
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Email
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-email-input"
                                placeholder="Nhập email"
                            />
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Website
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-website-input"
                                placeholder="Nhập website (nếu có)"
                            />
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col-full">
                            <label className="enterprise-detail-label">
                                Fax
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-fax-input"
                                placeholder="Nhập số fax (nếu có)"
                            />
                        </div>

                    </div>

                    {/* <!-- dia chi --> */}
                    <div className="enterprise-detail-address-title">
                        Địa chỉ trụ sở chính
                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col-full">
                            <label className="enterprise-detail-label">
                                Số nhà, đường
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-address-input"
                                placeholder="Nhập số nhà, tên đường"
                            />
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Tỉnh/Thành phố
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <select
                                className="enterprise-detail-city-select"
                            >
                                <option>An Giang</option>
                            </select>
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Huyện/Thị xã/Thành phố
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <select
                                className="enterprise-detail-district-select"
                            >
                                <option>TP. Long Xuyên</option>
                            </select>
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Xã/Phường/Thị trấn
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <select
                                className="enterprise-detail-ward-select"
                            >
                                <option>Phường Mỹ Long</option>
                            </select>
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Mã bưu chính
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-postal-input"
                                placeholder="Nhập mã bưu chính"
                            />
                        </div>

                    </div>

                    {/* <!-- map --> */}
                    <div className="enterprise-detail-map-title">
                        Vị trí trên bản đồ
                    </div>

                    <div className="enterprise-detail-map-search-wrapper">

                        <input
                            type="text"
                            className="enterprise-detail-map-search-input"
                            placeholder="Nhập địa chỉ để tìm trên bản đồ"
                        />

                        <span className="enterprise-detail-map-search-icon">
                            🔍
                        </span>

                    </div>
{/* 
                    <div className="enterprise-detail-map-wrapper">

                        <div className="enterprise-detail-map-zoom-control">

                            <button
                                className="enterprise-detail-map-plus-btn"
                            >
                                +
                            </button>

                            <button
                                className="enterprise-detail-map-minus-btn"
                            >
                                −
                            </button>

                        </div>

                        <div className="enterprise-detail-map-marker">
                            📍
                        </div>

                    </div> */}

                    {/* BẢN ĐỒ */}
                      {/* <div className="map-location-main">
      <div id="map-location-container"></div>

      <button className="map-location-button">
        Chọn vị trí trên bản đồ
      </button>
      </div>

                    <button className="enterprise-detail-map-button">
                        Chọn vị trí trên bản đồ
                    </button> */}
                     <div className="map-location-wrapper">

    <div className="map-location-background"></div>

    <div className="map-location-zoom">
      <button className="map-location-zoom-in">+</button>
      <button className="map-location-zoom-out">−</button>
    </div>

    {/* <div className="map-location-pin"></div> */}

    <div className="map-location-button">
      <button className="map-location-button-item">
        Chọn vị trí trên bản đồ
      </button>
    </div>

  </div>

                </div>

            </div>

            {/* <!-- right --> */}
            <div className="enterprise-detail-right">

                <div className="enterprise-detail-right-card">

                    <h3 className="enterprise-detail-section-title">
                        Thông tin người đại diện
                    </h3>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Họ và tên
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-fullname-input"
                                placeholder="Nhập họ và tên"
                            />
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Chức danh
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-position-input"
                                placeholder="Nhập chức danh"
                            />
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Số CCCD/CMND/Hộ chiếu
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-identity-input"
                                placeholder="Nhập số CCCD/CMND/Hộ chiếu"
                            />
                        </div>

                        <div className="enterprise-detail-col">
                            <label className="enterprise-detail-label">
                                Ngày cấp
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <input
                                type="date"
                                className="enterprise-detail-date-input"
                            />
                        </div>

                    </div>

                    <div className="enterprise-detail-row">

                        <div className="enterprise-detail-col-full">
                            <label className="enterprise-detail-label">
                                Nơi cấp
                                <span className="enterprise-detail-required">
                                    *
                                </span>
                            </label>

                            <input
                                type="text"
                                className="enterprise-detail-place-input"
                                placeholder="Nhập nơi cấp"
                            />
                        </div>

                    </div>

                </div>

                {/* <!-- upload --> */}
                <div className="enterprise-detail-upload-card">

                    <h3 className="enterprise-detail-section-title">
                        Thông tin bổ sung
                    </h3>

                    <label className="enterprise-detail-label">
                        Giấy chứng nhận đăng ký doanh nghiệp
                    </label>

                    <div className="enterprise-detail-upload-box">

                        <div className="enterprise-detail-upload-icon">
                            📄
                        </div>

                        <div className="enterprise-detail-upload-content">

                            <div className="enterprise-detail-upload-text">
                                Kéo thả file vào đây hoặc
                            </div>

                            <div className="enterprise-detail-upload-note">
                                Định dạng .pdf, .jpg, .png (Tối đa 10MB)
                            </div>

                        </div>

                        <button className="enterprise-detail-upload-btn">
                            Chọn file
                        </button>

                    </div>

                    {/* <!-- ghi chu --> */}
                    <div className="enterprise-detail-note-wrapper">

                        <label className="enterprise-detail-label">
                            Ghi chú
                        </label>

                        <textarea
                            className="enterprise-detail-note-textarea"
                            placeholder="Nhập ghi chú (nếu có)"
                        ></textarea>

                        <div className="enterprise-detail-note-count">
                            0/500
                        </div>

                    </div>

                    {/* <!-- radio --> */}
                    <div className="enterprise-detail-status-wrapper">

                        <label className="enterprise-detail-label">
                            Tình trạng hoạt động
                            <span className="enterprise-detail-required">
                                    *
                                </span>
                        </label>

                        <div className="enterprise-detail-radio-group">

                            <label className="enterprise-detail-radio-item">

                                <input
                                    type="radio"
                                    name="status"
                                    checked
                                />

                                <span className="enterprise-detail-radio-text">
                                    Đang hoạt động
                                </span>

                            </label>

                            <label className="enterprise-detail-radio-item">

                                <input
                                    type="radio"
                                    name="status"
                                />

                                <span className="enterprise-detail-radio-text">
                                    Tạm dừng hoạt động
                                </span>

                            </label>

                            <label className="enterprise-detail-radio-item">

                                <input
                                    type="radio"
                                    name="status"
                                />

                                <span className="enterprise-detail-radio-text">
                                    Ngừng hoạt động
                                </span>

                            </label>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        {/* <!-- footer --> */}
        {/* <div className="enterprise-detail-footer-wrapper">

            <button className="enterprise-detail-back-btn">
                ← Quay lại
            </button>

            <div className="enterprise-detail-footer-right">

                <button className="enterprise-detail-cancel-btn">
                    Hủy
                </button>

                <button className="enterprise-detail-save-btn">
                    💾 Lưu tạm
                </button>

                <button className="enterprise-detail-next-btn">
                    Tiếp tục →
                </button>

            </div>

        </div> */}

    </div>

                      <div className="enterprise-footer-button">
                        <button
                          className="enterprise-back-button"
                          onClick={handleBack}
                        >
                          Quay lại
                        </button>

                        <div className="enterprise-footer-right">
                          <button className="enterprise-save-button">
                            Lưu tạm
                          </button>

                          <button
                            className="enterprise-next-button"
                            onClick={handleNext}
                          >
                            Tiếp tục
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* STEP 4 */}
                  {step === 4 && (
                    <div className="enterprise-next-step">
                      <div className="them-doanh-nghiep-wrapper">

    {/* <!-- breadcrumb --> */}
    {/* <div className="them-doanh-nghiep-breadcrumb">
      <span className="them-doanh-nghiep-breadcrumb-item">Trang chủ</span>
      <span className="them-doanh-nghiep-breadcrumb-arrow">›</span>

      <span className="them-doanh-nghiep-breadcrumb-item">Doanh nghiệp</span>
      <span className="them-doanh-nghiep-breadcrumb-arrow">›</span>

      <span className="them-doanh-nghiep-breadcrumb-active">
        Thêm doanh nghiệp
      </span>
    </div> */}

    {/* <!-- title --> */}
    <div className="them-doanh-nghiep-title">
      Thêm doanh nghiệp
    </div>

    {/* <!-- step --> */}
    {/* <div className="them-doanh-nghiep-step-wrapper">

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-active">
          ✓
        </div>

        <div className="them-doanh-nghiep-step-text-active">
          Thông tin chung
        </div>

        <div className="them-doanh-nghiep-step-check">
          ✓
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-active">
          ✓
        </div>

        <div className="them-doanh-nghiep-step-text-active">
          Thông tin chi tiết
        </div>

        <div className="them-doanh-nghiep-step-check">
          ✓
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-current">
          3
        </div>

        <div className="them-doanh-nghiep-step-text-current">
          Tài liệu đính kèm
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-default">
          4
        </div>

        <div className="them-doanh-nghiep-step-text-default">
          Xác nhận
        </div>
      </div>

    </div> */}

    {/* <!-- content --> */}
    <div className="them-doanh-nghiep-content">

      {/* <!-- left --> */}
      <div className="them-doanh-nghiep-left">

        {/* <!-- required docs --> */}
        <div className="them-doanh-nghiep-card">

          <div className="them-doanh-nghiep-card-title">
            Tài liệu bắt buộc
          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Giấy chứng nhận đăng ký doanh nghiệp <span>*</span>
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Giấy chứng nhận đăng ký đầu tư (nếu có) <span>*</span>
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Điều lệ công ty <span>*</span>
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Báo cáo tài chính năm gần nhất <span>*</span>
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Giấy tờ pháp lý khác có liên quan <span>*</span>
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

        </div>

        {/* <!-- optional docs --> */}
        <div className="them-doanh-nghiep-card">

          <div className="them-doanh-nghiep-card-title">
            Tài liệu bổ sung (không bắt buộc)
          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Hồ sơ năng lực
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Giấy phép môi trường
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- item --> */}
          <div className="them-doanh-nghiep-upload-item">

            <div className="them-doanh-nghiep-upload-left">
              <div className="them-doanh-nghiep-upload-name">
                Các tài liệu khác
              </div>

              <div className="them-doanh-nghiep-upload-desc">
                Định dạng: pdf, jpg, .png (Tối đa 10MB)
              </div>
            </div>

            <div className="them-doanh-nghiep-upload-right">
              <input
                className="them-doanh-nghiep-upload-input"
                type="file"
              />

              <button className="them-doanh-nghiep-upload-button">
                ⤴ Chọn file
              </button>
            </div>

          </div>

          {/* <!-- note --> */}
          <div className="them-doanh-nghiep-note">

            <div className="them-doanh-nghiep-note-icon">
              i
            </div>

            <div className="them-doanh-nghiep-note-content">

              <div className="them-doanh-nghiep-note-title">
                Lưu ý
              </div>

              <div className="them-doanh-nghiep-note-text">
                Vui lòng đính kèm đầy đủ các tài liệu bắt buộc để hồ sơ được tiếp nhận và xử lý.
              </div>

              <div className="them-doanh-nghiep-note-text">
                Tổng dung lượng file tối đa 50MB.
              </div>

            </div>

          </div>

        </div>

      </div>

      {/* <!-- right --> */}
      <div className="them-doanh-nghiep-right">

        {/* <!-- guide --> */}
        <div className="them-doanh-nghiep-guide-card">

          <div className="them-doanh-nghiep-guide-title">
            Hướng dẫn
          </div>

          <ul className="them-doanh-nghiep-guide-list">
            <li className="them-doanh-nghiep-guide-item">
              Chỉ chấp nhận file có định dạng: .pdf, .jpg, .png
            </li>

            <li className="them-doanh-nghiep-guide-item">
              Dung lượng mỗi file không vượt quá 10MB
            </li>

            <li className="them-doanh-nghiep-guide-item">
              Tên file nên ngắn gọn, dễ nhận biết nội dung
            </li>

            <li className="them-doanh-nghiep-guide-item">
              Các tài liệu sẽ được sử dụng để thẩm định và lưu trữ hồ sơ doanh nghiệp
            </li>
          </ul>

        </div>

        {/* <!-- uploaded --> */}
        <div className="them-doanh-nghiep-uploaded-card">

          <div className="them-doanh-nghiep-uploaded-title">
            Danh sách file đã tải lên (0)
          </div>

          <div className="them-doanh-nghiep-empty-wrapper">

            <div className="them-doanh-nghiep-empty-icon">
              📂
            </div>

            <div className="them-doanh-nghiep-empty-text">
              Chưa có file nào được tải lên
            </div>

          </div>

        </div>

      </div>

    </div>

    {/* <!-- footer button --> */}
    <div className="them-doanh-nghiep-footer">

      <button className="them-doanh-nghiep-back-button"  onClick={handleBack}>
        ← Quay lại
      </button>

      <div className="them-doanh-nghiep-footer-right">

        <button className="them-doanh-nghiep-cancel-button"  onClick={handleBack}>
          Hủy
        </button>

        <button className="them-doanh-nghiep-save-button">
          💾 Lưu tạm
        </button>

        <button className="them-doanh-nghiep-next-button"  onClick={handleNext}>
          Tiếp tục →
        </button>

      </div>

    </div>

  </div>

                      {/* <div className="enterprise-footer-button">
                        <button
                          className="enterprise-back-button"
                          onClick={handleBack}
                        >
                          Quay lại
                        </button>

                        <div className="enterprise-footer-right">
                          <button className="enterprise-save-button">
                            Lưu tạm
                          </button>

                          <button
                            className="enterprise-next-button"
                            onClick={handleNext}
                          >
                            Tiếp tục
                          </button>
                        </div>
                      </div> */}
                    </div>
                  )}

                  {/* STEP 5 */}
                  {step === 5 && (
                    <div className="enterprise-next-step">
                      {/* Phần này */}
      <div className="them-doanh-nghiep-wrapper-five">

    {/* breadcrumb */}
    {/* <div className="them-doanh-nghiep-breadcrumb">
      <span className="them-doanh-nghiep-breadcrumb-item">
        Trang chủ
      </span>

      <span className="them-doanh-nghiep-breadcrumb-arrow">
        &gt;
      </span>

      <span className="them-doanh-nghiep-breadcrumb-item">
        Doanh nghiệp
      </span>

      <span className="them-doanh-nghiep-breadcrumb-arrow">
        &gt;
      </span>

      <span className="them-doanh-nghiep-breadcrumb-item-active">
        Thêm doanh nghiệp
      </span>
    </div> */}

    {/* title */}
    <h2 className="them-doanh-nghiep-title">
      Thêm doanh nghiệp
    </h2>

    {/* step */}
    {/* <div className="them-doanh-nghiep-step-wrapper">

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-active">
          ✓
        </div>

        <div className="them-doanh-nghiep-step-text">
          Thông tin chung
        </div>

        <div className="them-doanh-nghiep-step-check">
          ✓
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-active">
          ✓
        </div>

        <div className="them-doanh-nghiep-step-text">
          Thông tin chi tiết
        </div>

        <div className="them-doanh-nghiep-step-check">
          ✓
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-active">
          ✓
        </div>

        <div className="them-doanh-nghiep-step-text">
          Tài liệu đính kèm
        </div>

        <div className="them-doanh-nghiep-step-check">
          ✓
        </div>
      </div>

      <div className="them-doanh-nghiep-step-line"></div>

      <div className="them-doanh-nghiep-step-item">
        <div className="them-doanh-nghiep-step-circle-current">
          4
        </div>

        <div className="them-doanh-nghiep-step-text-current">
          Xác nhận
        </div>
      </div>

    </div> */}

    {/* success */}
    <div className="them-doanh-nghiep-success-box">

      <div className="them-doanh-nghiep-success-icon">
        ✓
      </div>

      <div className="them-doanh-nghiep-success-content">

        <div className="them-doanh-nghiep-success-title">
          Xác nhận thông tin
        </div>

        <div className="them-doanh-nghiep-success-desc">
          Vui lòng kiểm tra lại thông tin doanh nghiệp trước khi lưu.
        </div>

      </div>

    </div>

    {/* info */}
    <div className="them-doanh-nghiep-info-wrapper">

      {/* left */}
      <div className="them-doanh-nghiep-info-col">

        <div className="them-doanh-nghiep-info-card">

          <div className="them-doanh-nghiep-info-title">
            1. Thông tin chung
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tên doanh nghiệp
            </span>

            <span className="them-doanh-nghiep-info-value">
              Công ty TNHH An Giang Garment
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tên viết tắt
            </span>

            <span className="them-doanh-nghiep-info-value">
              An Giang Garment Co., Ltd
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Mã số thuế
            </span>

            <span className="them-doanh-nghiep-info-value">
              1601234567
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Số ĐKKD
            </span>

            <span className="them-doanh-nghiep-info-value">
              1601234567
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Loại hình doanh nghiệp
            </span>

            <span className="them-doanh-nghiep-info-value">
              Công ty TNHH 2 thành viên trở lên
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Ngày cấp ĐKKD
            </span>

            <span className="them-doanh-nghiep-info-value">
              15/06/2015
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Địa chỉ trụ sở chính
            </span>

            <span className="them-doanh-nghiep-info-value">
              Số 123, đường Trần Hưng Đạo, P. Mỹ Thới, TP. Long Xuyên, tỉnh An Giang
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Điện thoại
            </span>

            <span className="them-doanh-nghiep-info-value">
              0296 1234 567
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Email
            </span>

            <span className="them-doanh-nghiep-info-value">
              info@angianggarment.vn
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Website
            </span>

            <span className="them-doanh-nghiep-info-value-link">
              https://www.angianggarment.vn
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Trạng thái
            </span>

            <span className="them-doanh-nghiep-status-active">
              Đang hoạt động
            </span>
          </div>

        </div>

      </div>

      {/* center */}
      <div className="them-doanh-nghiep-info-col">

        <div className="them-doanh-nghiep-info-card">

          <div className="them-doanh-nghiep-info-title">
            2.Người đại diện theo pháp luật
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Họ và tên
            </span>

            <span className="them-doanh-nghiep-info-value">
              Nguyễn Văn An
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Chức danh
            </span>

            <span className="them-doanh-nghiep-info-value">
              Giám đốc
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Số CCCD/CMND/Hộ chiếu
            </span>

            <span className="them-doanh-nghiep-info-value">
              089012345678
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Số điện thoại
            </span>

            <span className="them-doanh-nghiep-info-value">
              0912 345 678
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Email
            </span>

            <span className="them-doanh-nghiep-info-value-mail">
              nguyenvanan@angianggarment.vn
            </span>
          </div>

        </div>

        <div className="them-doanh-nghiep-info-card them-doanh-nghiep-info-card-top">

          <div className="them-doanh-nghiep-info-title">
            3.Ngành nghề kinh doanh chính
          </div>

          <div className="them-doanh-nghiep-nganh-header">
            <span className="them-doanh-nghiep-nganh-stt">
              STT
            </span>

            <span className="them-doanh-nghiep-nganh-name">
              Ngành nghề chính
            </span>

            <span className="them-doanh-nghiep-nganh-code">
              Mã ngành
            </span>
          </div>

          <div className="them-doanh-nghiep-nganh-row">
            <span className="them-doanh-nghiep-nganh-stt">
              1
            </span>

            <span className="them-doanh-nghiep-nganh-name">
              Sản xuất trang phục (trừ trang phục từ da lông thú)
            </span>

            <span className="them-doanh-nghiep-nganh-code">
              1410
            </span>
          </div>

          <div className="them-doanh-nghiep-nganh-row">
            <span className="them-doanh-nghiep-nganh-stt">
              2
            </span>

            <span className="them-doanh-nghiep-nganh-name">
              Sản xuất hàng dệt sẵn (trừ trang phục)
            </span>

            <span className="them-doanh-nghiep-nganh-code">
              1392
            </span>
          </div>

          <div className="them-doanh-nghiep-xem-them">
            Xem thêm 3 ngành nghề khác
          </div>

        </div>

      </div>

      {/* right */}
      <div className="them-doanh-nghiep-info-col">

        <div className="them-doanh-nghiep-info-card">

          <div className="them-doanh-nghiep-info-title">
            4.Vốn và quy mô
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tổng vốn đầu tư
            </span>

            <span className="them-doanh-nghiep-info-value">
              80.000.000.000 đồng
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Vốn điều lệ
            </span>

            <span className="them-doanh-nghiep-info-value">
              50.000.000.000 đồng
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tổng số lao động
            </span>

            <span className="them-doanh-nghiep-info-value">
              1.250 người
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Diện tích đất thuê
            </span>

            <span className="them-doanh-nghiep-info-value">
              10 ha
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Thời gian hoạt động
            </span>

            <span className="them-doanh-nghiep-info-value">
              Từ ngày 15/06/2015
            </span>
          </div>

        </div>

        <div className="them-doanh-nghiep-info-card them-doanh-nghiep-info-card-top">

          <div className="them-doanh-nghiep-info-title">
            5.Tài liệu đính kèm
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tài liệu bắt buộc
            </span>

            <span className="them-doanh-nghiep-info-value-file">
              05 file
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tài liệu bổ sung
            </span>

            <span className="them-doanh-nghiep-info-value-file">
              03 file
            </span>
          </div>

          <div className="them-doanh-nghiep-info-row">
            <span className="them-doanh-nghiep-info-label">
              Tổng dung lượng
            </span>

            <span className="them-doanh-nghiep-info-value-file">
              28.4 MB
            </span>
          </div>

          <div className="them-doanh-nghiep-xem-file">
            Xem danh sách file đính kèm
          </div>

        </div>

      </div>

    </div>

    {/* note */}
    <div className="them-doanh-nghiep-note-box">

      <div className="them-doanh-nghiep-note-icon">
        i
      </div>

      <div className="them-doanh-nghiep-note-content">

        <div className="them-doanh-nghiep-note-title">
          Lưu ý
        </div>

        <div className="them-doanh-nghiep-note-desc">
          Sau khi lưu, thông tin doanh nghiệp sẽ được gửi đến Ban quản lý khu kinh tế tỉnh An Giang để thẩm định và phê duyệt.
        </div>

        <div className="them-doanh-nghiep-note-desc">
          Bạn có thể theo dõi trạng thái hồ sơ tại danh sách doanh nghiệp.
        </div>

      </div>

    </div>

    {/* button */}
    <div className="them-doanh-nghiep-button-wrapper">

      <button className="them-doanh-nghiep-button-back"  onClick={handleBack}>
        ← Quay lại
      </button>

      <div className="them-doanh-nghiep-button-right">

        <button className="them-doanh-nghiep-button-cancel"  onClick={handleBack}>
          Hủy
        </button>

        <button className="them-doanh-nghiep-button-save">
          💾 Lưu tạm
        </button>

        <button className="them-doanh-nghiep-button-confirm" onClick={handleSave}>
          Xác nhận và lưu ✓
        </button>

      </div>

    </div>

  </div>

                      {/* <div className="enterprise-footer-button">
                        <button
                          className="enterprise-back-button"
                          onClick={handleBack}
                        >
                          Quay lại
                        </button>

                        <div className="enterprise-footer-right">
                          <button className="enterprise-save-button">
                            Lưu tạm
                          </button>

                          <button
                            className="enterprise-next-button"
                            onClick={handleSave}
                          >
                            Xác nhận và lưu
                          </button>
                        </div>
                      </div> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}


    </div>
  


        );
    }


export default DoanhNghiep;